export default {
  ratingMainDiv: 'rating-variants inline-block align-middle leading-0',
  ratingWrapper: 'rating-wrapper',
  ratingSpan: 'rating relative block w-77',
  emptyStar: 'primaryImage w-77 h-15',
  ratingImg: 'rating-primary-image absolute left-0 overflow-hidden ',
  completeStar: 'rating-secondary-image relative inline-block w-77 h-15',
};
